import React, { Component } from 'react';
import './display-traffic.css';
import moment from 'moment-timezone';


class DisplayTraffic extends Component {
  render() {


    let {
      unix_timestamp,
      sum_viral,
      sum_twts,
      sum_girlposts,
      sum_realdonaldtrump,
      sum_sodamntrue,
      sum_freddyamazin,
      sum_cnn,
      sum_foxnews,
      sum_nytimes,
      sum_youtube,
      viral_value_global,
      girlposts_value_global,
      sodamntrue_value_global,
      realdonaldtrump_value_global,
      freddyamazin_value_global,
      cnn_value_global,
      foxnews_value_global,
      nytimes_value_global,
      youtube_value_global,
      sum_lmao,
      sum_girlfriendnotes,
      sum_country_voices,
      // sum_booty,
      // sum_ilgdaily,
      sum_googlefacts,
      sum_femaies,
      sum_tumblrfunniez,
      sum_relatablequote,
      sum_soreiatable,
      lmao_value_global,
      girlfriendnotes_value_global,
      country_voices_value_global,
      // booty_value_global,
      // ilgdaily_value_global,
      googlefacts_value_global,
      femaies_value_global,
      tumblrfunniez_value_global,
      relatablequote_value_global,
      soreiatable_value_global
    }
      = this.props;


    let date = moment.tz(unix_timestamp, "America/New_York")
      .format('ddd D MMM h:mm A');


    return (
      <div id="dtf-d1a">
        <div id="dtf-d2a"
             style={{
               textAlign: 'center'
             }}
        >
          <div>

          </div>
          <br/>
          <div>
            real-time random sample of <span style={{
            fontWeight: 'bold'
          }}>{sum_twts.toLocaleString()}</span> worldwide retweets <br/>
            + replies + mentions on Twtr (lang: English)
            <br/>
            <br/>
            <span style={{
              color: 'lightgray'
            }}>
              retweets + replies + mentions
            </span>
            <br/>
          </div>
          <br/>
          <div id="dtf-d3a">
            <div id="dtf-d4a">
              <div className="dtf-d7a">
                Viral Digital Talent Team: <span style={{
                color: 'lightgray'
              }}>{sum_viral.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {viral_value_global.toLocaleString()}%
              </span>
              </div>
              <br/>
              <div className="dtf-d7a">
                @girlposts: <span style={{
                color: 'lightgray'
              }}>{sum_girlposts.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {girlposts_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @sodamntrue: <span style={{
                color: 'lightgray'
              }}>{sum_sodamntrue.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {sodamntrue_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @freddyamazin: <span style={{
                color: 'lightgray'
              }}>{sum_freddyamazin.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {freddyamazin_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @LMAO: <span style={{
                color: 'lightgray'
              }}>{sum_lmao.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {lmao_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @GirlfriendNotes: <span style={{
                color: 'lightgray'
              }}>{sum_girlfriendnotes.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {girlfriendnotes_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @Country_Voices: <span style={{
                color: 'lightgray'
              }}>{sum_country_voices.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {country_voices_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @GoogleFacts: <span style={{
                color: 'lightgray'
              }}>{sum_googlefacts.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {googlefacts_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @Femaies: <span style={{
                color: 'lightgray'
              }}>{sum_femaies.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {femaies_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @TumblrFunniez: <span style={{
                color: 'lightgray'
              }}>{sum_tumblrfunniez.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {tumblrfunniez_value_global.toLocaleString()}%
              </span>
              </div>

              <div className="dtf-d7a">
                @RelatableQuote: <span style={{
                color: 'lightgray'
              }}>{sum_relatablequote.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {relatablequote_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d7a">
                @SoReIatable: <span style={{
                color: 'lightgray'
              }}>{sum_soreiatable.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {soreiatable_value_global.toLocaleString()}%
              </span>
              </div>
            </div>
            <div id="dtf-d5a">
              <div className="dtf-d8a">
                @realdonaldtrump: <span style={{
                color: 'lightgray'
              }}>{sum_realdonaldtrump.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {realdonaldtrump_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d8a">
                @cnn: <span style={{
                color: 'lightgray'
              }}>{sum_cnn.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {cnn_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d8a">
                @foxnews: <span style={{
                color: 'lightgray'
              }}>{sum_foxnews.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {foxnews_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d8a">
                @nytimes: <span style={{
                color: 'lightgray'
              }}>{sum_nytimes.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {nytimes_value_global.toLocaleString()}%
              </span>
              </div>
              <div className="dtf-d8a">
                @youtube: <span style={{
                color: 'lightgray'
              }}>{sum_youtube.toLocaleString()}</span>
                <span style={{
                  fontWeight: 'bold'
                }}>
            <br/>
                  {youtube_value_global.toLocaleString()}%
              </span>
              </div>
            </div>
          </div>
          <br/>
          <div>
            <br/>
            reloads every time 2000 new tweets have<br/>
            been filtered (~4mins) <br/><br/>data date: {date} EDT
          </div>
        </div>
      </div>
    );
  }
}


export default DisplayTraffic;


// WEBPACK FOOTER //
// ./src/containers/traffic/DisplayTraffic.js